import { z } from 'zod';

export const RunnerToolSchema = z.enum([
  'bloodhound',
  'certipy',
  'azurehound',
  'rusthound',
  'nmap',
  'credential_verify',
]);

export type RunnerTool = z.infer<typeof RunnerToolSchema>;

export const RunnerOutputNameSchema = z
  .string()
  .regex(
    /^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/,
    'outputName must be a safe basename (letters, digits, . _ -; max 64 chars)',
  );

export const RunnerTaskInvocationSchema = z.object({
  tool: RunnerToolSchema,
  outputName: RunnerOutputNameSchema,
  needsCredentials: z.boolean().default(false),
  args: z.record(z.string(), z.union([z.string(), z.array(z.string())])),
});

export type RunnerTaskInvocation = z.infer<typeof RunnerTaskInvocationSchema>;

export const RunnerTaskSpecSchema = z.object({
  runId: z.string().min(1),
  networkId: z.string().min(1),
  resultUploadUrl: z.string().url(),
  resultContentType: z.string().default('application/zip'),
  tasks: z.array(RunnerTaskInvocationSchema).min(1),
});

export type RunnerTaskSpec = z.infer<typeof RunnerTaskSpecSchema>;

export const parseRunnerTaskSpec = (value: unknown): RunnerTaskSpec =>
  RunnerTaskSpecSchema.parse(value);
